import { render, staticRenderFns } from "./RecommendationPopupBlock.vue?vue&type=template&id=20139630&scoped=true&"
import script from "./RecommendationPopupBlock.vue?vue&type=script&lang=js&"
export * from "./RecommendationPopupBlock.vue?vue&type=script&lang=js&"
import style0 from "./RecommendationPopupBlock.vue?vue&type=style&index=0&id=20139630&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20139630",
  null
  
)

export default component.exports